export default function Spinner({ size = 20, className = "" }) {
  return (
    <svg
      className={`animate-spin ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12" cy="12" r="10"
        stroke="currentColor" strokeOpacity="0.2" strokeWidth="3"
      />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor" strokeWidth="3" strokeLinecap="round"
      />
    </svg>
  );
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center py-20 text-teal">
      <Spinner size={32} />
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="bg-white rounded-[10px] shadow-card p-5 animate-pulse">
      <div className="h-3 bg-gray-200 rounded w-20 mb-3" />
      <div className="h-7 bg-gray-200 rounded w-16 mb-3" />
      <div className="h-3 bg-gray-100 rounded w-32" />
    </div>
  );
}
